import { EnumType } from 'json-to-graphql-query';

import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import { AppUserGraphQLService } from './app-user.service';

export interface AssigneeGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

export class AssigneeGraphQLService
    extends AppUserGraphQLService
    implements AssigneeGraphQLServiceInterface
{
    public additionalWhere(): Record<string, RHFGroupFieldValue> {
        return {
            'additionalWhere.assignee': {
                id: 'additionalWhere.assignee',
                inputType: 'input',
                key: 'isCustomer',
                operator: '=',
                value: new EnumType('false'),
            },
        };
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('assignee', {
            userId: this.getQueryById(),
        });
    }
}
